import {
  ColorCodes,
  Text,
  VContainer
} from '@vodacom/web-common';

import {
  withScreenViewTagging
} from 'hocs';

export const TextOnlyErrorUI = props => {

  TextOnlyErrorUI.pageName = props.pageName;

  TextOnlyErrorUI.tagViewData = {
    ...props.tagViewData
  };

  return (

    <VContainer>

      <Text
        color={ColorCodes.Grey9}
        fontFamily={'Roboto'}
        fontSize={'16px'}
        padding={'32px 0'}
        textAlign={'center'} >

        {props.title}
      </Text>
    </VContainer>
  );
};

export const TextOnlyError = withScreenViewTagging(TextOnlyErrorUI);